export default "__VITE_ASSET__5f26c00e__"